export default __webpack_public_path__ + "static/media/MOTIVO_14.6338f1c7.jpg";